import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RecoveryButtonProps {
  onClick: () => void;
  className: string;
  starTone?: 'cream' | 'forest';
}
const sparkleUrl = 'https://cdn.magicpatterns.com/uploads/uszYpUgDHbmVmVvdioqNYy/Icon_OffWhite.svg';
export function RecoveryButton({
  onClick,
  className,
  starTone = 'cream'
}: RecoveryButtonProps) {
  const shouldReduceMotion = useReducedMotion();
  const starColor = starTone === 'cream' ? '#F7F4EC' : '#BB5E40';
  return <motion.button type="button" onClick={onClick} initial="rest" animate="rest" whileHover={shouldReduceMotion ? undefined : 'hover'} whileTap={shouldReduceMotion ? undefined : {
    scale: 0.98
  }} transition={{
    type: 'spring',
    stiffness: 420,
    damping: 24
  }} className={`inline-flex items-center justify-center gap-2 ${className}`} data-id="element-1976" data-mp="dhvugicgeckg">
      <span data-id="element-1977" data-mp="1xx7itvifsheb">Recovery</span>
      <motion.span aria-hidden="true" variants={{
      rest: {
        scale: 1,
        rotate: 0,
        opacity: 0.96
      },
      hover: {
        scale: [1, 1.18, 1.05],
        rotate: [0, -7, 2],
        opacity: 1,
        transition: {
          duration: 0.32,
          ease: 'easeOut'
        }
      }
    }} className="h-5 w-5 shrink-0" style={{
      backgroundColor: starColor,
      WebkitMaskImage: `url(${sparkleUrl})`,
      maskImage: `url(${sparkleUrl})`,
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      maskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskSize: 'contain'
    }} data-id="element-1978" data-mp="1xxhe9ym93gre" />
    </motion.button>;
}